module.exports = __webpack_public_path__ + "img/rencaixinyongka@3x.41b29d38.svg";